<div class="next__container">
  <!-- User does not have a team yet or has invitation status, so show the select overview -->
  <div *ngIf="teamLoaded && (!team || loggedInUser.membershipStatus === TeamMembershipStatus.INVITATION)" class="next__no-team-container">
    <img src="assets/icons/general/search.svg" class="next__no-team-icon" />
    <p class="next__no-team-text">{{ 'STATS.CHALLENGE_NEXT.membershipStatus.noMember' | translate }}</p>
    <app-button
      type="primary"
      [label]="'STATS.CHALLENGE_NEXT.actions.participate' | translate"
      (click)="navigateSelectTeam(challenge?._id)"
    ></app-button>
  </div>

  <!-- User is a member of the team or has submitted an application -->
  <div *ngIf="team && loggedInUser.membershipStatus !== TeamMembershipStatus.INVITATION" class="next__team-container">
    <a
      *ngIf="loggedInUser?.membershipStatus === TeamMembershipStatus.MEMBER && !displayLeaveTeamDialog && !displayDeleteTeamDialog"
      class="next__team-generateMailButton"
      [href]="inviteMembersTemplate"
    >
      <app-button type="primary" [label]="'STATS.CHALLENGE_NEXT.actions.generateInvitationMail' | translate"> </app-button
    ></a>

    <p class="next__team-name">{{ 'STATS.CHALLENGE_NEXT.teamName' | translate }}{{ team?.name }}</p>

    <ng-container *ngIf="!displayLeaveTeamDialog && !displayDeleteTeamDialog">
      <p class="next__team-status">
        {{ 'STATS.CHALLENGE_NEXT.membershipStatus.yourStatus' | translate }}
        <span *ngIf="loggedInUser?.membershipStatus === TeamMembershipStatus.APPLICATION" class="next__team-status--application">
          {{ 'STATS.CHALLENGE_NEXT.membershipStatus.applicationPending' | translate }}
        </span>
        <span
          *ngIf="!loggedInUser?.isFounder && loggedInUser?.membershipStatus === TeamMembershipStatus.MEMBER"
          class="next__team-status--member"
        >
          {{ 'STATS.CHALLENGE_NEXT.membershipStatus.member' | translate }}
        </span>
        <span *ngIf="loggedInUser?.isFounder" class="next__team-status--member">
          {{ 'STATS.CHALLENGE_NEXT.membershipStatus.founder' | translate }}
        </span>
      </p>

      <div class="next__team-table-heading">
        <span class="next__team-table-heading-spots-left">
          <span
            *ngIf="challenge?.maximumTeamMembers"
            [ngClass]="{
              'next__team-table-heading-spots-left-count': true,
              'next__team-table-heading-spots-left-count--full':
                team.userGroups.members.length + team.userGroups.invitations.length >= challenge.maximumTeamMembers
            }"
          >
            {{ team.userGroups.members.length + team.userGroups.invitations.length + '/' + challenge.maximumTeamMembers }}
          </span>
          {{ 'STATS.CHALLENGE_NEXT.slotsOccupied' | translate }}
        </span>
        <span
          *ngIf="challenge?.minimalTeamMembers && team.userGroups.members.length < challenge.minimalTeamMembers"
          class="next__team-table-heading-minimum-members"
          >{{ 'STATS.CHALLENGE_NEXT.minimumMembers' | translate: { members: challenge.minimalTeamMembers } }}
        </span>
      </div>

      <!-- For normal members and applicants of the team, invited members are not displayed -->
      <div class="next__team-members">
        <!-- Layout for founder splits users into groups by membership status with additional subheadings -->
        <p *ngIf="loggedInUser?.isFounder" class="next__team-table-heading-subheading">
          {{ 'STATS.CHALLENGE_NEXT.members' | translate }}
        </p>

        <app-next-challenge-user
          *ngFor="let user of team?.userGroups?.members; let i = index"
          [index]="i + 1"
          [user]="user"
          [challenge]="challenge"
          [team]="team"
        >
        </app-next-challenge-user>

        <!-- Also the invited members are displayed -->
        <p *ngIf="loggedInUser?.isFounder && team?.userGroups?.invitations?.length > 0" class="next__team-table-heading-subheading">
          {{ 'STATS.CHALLENGE_NEXT.invitedMembers' | translate }}
        </p>

        <app-next-challenge-user
          *ngFor="let user of team?.userGroups?.invitations; let i = index"
          [index]="i + 1 + team?.userGroups?.members.length"
          [user]="user"
          [challenge]="challenge"
          [team]="team"
        >
        </app-next-challenge-user>

        <p *ngIf="loggedInUser?.isFounder && team?.userGroups?.applications?.length > 0" class="next__team-table-heading-subheading">
          {{ 'STATS.CHALLENGE_NEXT.applications' | translate }}
        </p>

        <app-next-challenge-user *ngFor="let user of team?.userGroups?.applications" [user]="user" [challenge]="challenge" [team]="team">
        </app-next-challenge-user>

        <!-- Display section with users who declined their invitations -->
        <ng-container *ngIf="loggedInUser?.isFounder && team?.declinedInvitations?.length > 0">
          <p class="next__team-table-heading-subheading">
            {{ 'STATS.CHALLENGE_NEXT.declinedInvitations' | translate }}
          </p>

          <app-next-challenge-user
            *ngFor="let email of team.declinedInvitations"
            [user]="{ email: email }"
            [challenge]="challenge"
            [team]="team"
          >
          </app-next-challenge-user>
        </ng-container>

        <!-- Display section with users who left the team by themselves -->
        <ng-container *ngIf="loggedInUser?.isFounder && team?.teamLeavers?.length > 0">
          <p class="next__team-table-heading-subheading">
            {{ 'STATS.CHALLENGE_NEXT.teamLeavers' | translate }}
          </p>

          <app-next-challenge-user *ngFor="let email of team.teamLeavers" [user]="{ email: email }" [challenge]="challenge" [team]="team">
          </app-next-challenge-user>
        </ng-container>
      </div>

      <!-- For founders, an additional form is displayed which allows to invite users to the team -->
      <form *ngIf="loggedInUser?.isFounder" [formGroup]="inviteUserForm" action="" class="next__invite-container">
        <div class="next__invite">
          <p class="next__invite-heading">{{ 'STATS.CHALLENGE_NEXT.addMembers' | translate }}</p>
          <input
            *ngIf="team?.userGroups?.invitations.length + team?.userGroups?.members.length < challenge?.maximumTeamMembers"
            #inviteUser
            class="next__invite-input"
            type="email"
            [formControlName]="'email'"
            [placeholder]="'TEAMSELECT.teamDetails.enterEmail' | translate"
          />
          <input
            *ngIf="team?.userGroups?.invitations.length + team?.userGroups?.members.length >= challenge?.maximumTeamMembers"
            #inviteUser
            class="next__invite-input"
            type="email"
            [value]="'TEAMSELECT.teamDetails.memberlimitReached' | translate"
            disabled
          />
        </div>

        <app-button
          class="next__invite-button"
          type="primary"
          disabledStyle="secondary"
          [label]="'STATS.CHALLENGE_NEXT.actions.invite' | translate"
          [disabled]="
            inviteUserForm.invalid ||
            team?.userGroups?.invitations.length + team?.userGroups?.members.length >= challenge?.maximumTeamMembers
          "
          (onClick)="inviteUserToTeam()"
        ></app-button>
      </form>

      <div class="next__team-actions">
        <app-button
          *ngIf="loggedInUser?.membershipStatus === TeamMembershipStatus.MEMBER && !loggedInUser?.isFounder"
          type="error-light"
          [label]="'STATS.CHALLENGE_NEXT.actions.leaveTeam' | translate"
          (click)="showLeaveTeamDialog()"
        ></app-button>

        <app-button
          *ngIf="loggedInUser?.membershipStatus === TeamMembershipStatus.MEMBER && loggedInUser?.isFounder"
          type="error-light"
          [label]="'STATS.CHALLENGE_NEXT.actions.deleteTeam' | translate"
          (click)="showDeleteTeamDialog()"
        ></app-button>

        <app-button
          *ngIf="loggedInUser?.membershipStatus === TeamMembershipStatus.APPLICATION"
          type="primary"
          [label]="'STATS.CHALLENGE_NEXT.actions.cancelApplication' | translate"
          (click)="denyApplication(currentUser?._id)"
        ></app-button>
      </div>
    </ng-container>

    <div *ngIf="displayLeaveTeamDialog" class="next__dialog-container">
      <div class="next__dialog">
        <p class="next__dialog-text">
          {{ 'STATS.CHALLENGE_NEXT.leaveTeamHint' | translate }}
        </p>
        <p class="next__dialog-text">{{ 'STATS.CHALLENGE_NEXT.confirmLeaveTeam' | translate }}</p>
        <div class="next__dialog-buttons">
          <app-button
            type="primary"
            [label]="'STATS.CHALLENGE_NEXT.actions.cancel' | translate"
            (click)="displayLeaveTeamDialog = false"
          ></app-button>
          <app-button
            type="error-light"
            [label]="'STATS.CHALLENGE_NEXT.actions.leaveTeam' | translate"
            (click)="leaveTeam(challenge._id, team._id, currentUser?._id)"
          ></app-button>
        </div>
      </div>
    </div>

    <div *ngIf="displayDeleteTeamDialog" class="next__dialog-container">
      <div class="next__dialog">
        <p class="next__dialog-text">
          {{ 'STATS.CHALLENGE_NEXT.deleteTeamHint' | translate }}
        </p>
        <p class="next__dialog-text">{{ 'STATS.CHALLENGE_NEXT.confirmDeleteTeam' | translate }}</p>
        <div class="next__dialog-buttons">
          <app-button
            type="primary"
            [label]="'STATS.CHALLENGE_NEXT.actions.cancel' | translate"
            (click)="displayDeleteTeamDialog = false"
          ></app-button>
          <app-button
            type="error-light"
            [label]="'STATS.CHALLENGE_NEXT.actions.deleteTeam' | translate"
            (click)="deleteTeam(challenge._id, team._id)"
          ></app-button>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/challenge-statistics/components/next-challenge/next-challenge.component.html